import {Country} from "../../region/types/Country";
import {IUpdateCurrentTabAction, UPDATE_CURRENT_TAB} from "../actions/update_current_tab";
import {SearchTab} from "../types/SearchTab";

const initialState: {currentTab: SearchTab; country?: Country} = {currentTab: SearchTab.Regions, country: Country.POLAND};
export const currentTabReducer = (state = initialState, action: IUpdateCurrentTabAction): {currentTab: SearchTab; country?: Country} => {
    switch (action.type) {
        case UPDATE_CURRENT_TAB:
            return action.payload;
        default:
            return state;
    }
};
import {Country} from "../../region/types/Country";
import {IUpdateCurrentTabAction, UPDATE_CURRENT_TAB} from "../actions/update_current_tab";
import {SearchTab} from "../types/SearchTab";

const initialState: {currentTab: SearchTab; country?: Country} = {currentTab: SearchTab.Regions, country: Country.POLAND};
export const currentTabReducer = (state = initialState, action: IUpdateCurrentTabAction): {currentTab: SearchTab; country?: Country} => {
    switch (action.type) {
        case UPDATE_CURRENT_TAB:
            return action.payload;
        default:
            return state;
    }
};
